import { AfterContentInit, Component, Input } from '@angular/core';
import { PopoverListModel } from 'src/app/components/info-popover/popover-list.model';
import { PopoverModel } from 'src/app/components/info-popover/popover.model';

@Component({
  selector: 'app-input-label',
  templateUrl: './input-label.component.html',
})
export class InputLabelComponent implements AfterContentInit {
  @Input() label?: string;
  @Input() for?: string;
  @Input() inputContainer?: HTMLElement;
  @Input() biggerFont = false;
  @Input() isRequired = false;
  @Input() popoverInfo?: PopoverModel;

  constructor() {}

  ngAfterContentInit(): void {
    setTimeout(() => this.setFor());
  }

  private setFor() {
    if (!this.for) {
      this.for = this.findFirstInputName(this.inputContainer!);
      if (!this.for) {
        this.for = this.findAnyElementWithFormControlName(this.inputContainer!);
      }
    }
  }

  private findFirstInputName(htmlElement: HTMLElement): string {
    const inputs = htmlElement.getElementsByTagName('input');
    for (let i = 0; i < inputs.length; i++) {
      const input = inputs[i];
      const name = this.getNameFromInput(input);
      if (name) {
        return name;
      }
    }
    return null!;
  }

  private findAnyElementWithFormControlName(htmlElement: HTMLElement): string {
    const children = htmlElement.children;
    for (let i = 0; i < children.length; i++) {
      const child = children[i] as HTMLElement;
      let name = this.getNameFromHtmlElement(child);
      if (name) {
        return name;
      } else {
        name = this.findAnyElementWithFormControlName(child);
        if (name) {
          return name;
        }
      }
    }
    return null!;
  }

  private getNameFromInput(input: HTMLInputElement): string {
    if (input.name) {
      return input.name;
    }
    return this.getNameFromHtmlElement(input);
  }

  private getNameFromHtmlElement(element: HTMLElement): string {
    if (element.getAttribute('formControlName')) {
      return element.getAttribute('formControlName')!;
    } else if (element.id) {
      return element.id;
    } else if (element.getAttribute('ng-reflect-name')) {
      return element.getAttribute('ng-reflect-name')!;
    }
    return null!;
  }
}
